module.exports = __webpack_public_path__ + "img/bmcl_gallery18.dfc0ad74.jpg";